import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { getApiError } from "@src/utils/apiError";

import {
  updateBookmarkRequest,
  updateBookmarkSuccess,
  updateBookmarkFailure,
} from '../slice/updateBookmarkSlice';

import { patchBookmarkApi } from '../../api/apiService';

export function* handleUpdateBookmark(
  action: ReturnType<typeof updateBookmarkRequest>
): SagaIterator {
  try {
    const response: { data: any } = yield call(
      patchBookmarkApi,
      action.payload
    );

    yield put(updateBookmarkSuccess(response.data));
  } catch (error: unknown) {
    const apiError = getApiError(error);
    yield put(
        updateBookmarkFailure(
            apiError.message
        )
    );
}
}

export function* updateBookmarkSaga(): SagaIterator {
  yield takeLatest(
    updateBookmarkRequest.type,
    handleUpdateBookmark
  );
}